import TemplatePostActions from "../TemplatePost/TemplatePostActions";
import logger from "../../../../utils/LoggerFrontend";

export const duplicateMediaAsset = async (mediaAssetId) => {
  return new Promise((resolve) => {
    const ref = TemplatePostActions.duplicateMediaAsset.completed.listen((mediaAsset) => {
      logger.debug("PerformanceEditor", "duplicated media asset", { mediaAsset });
      resolve(mediaAsset?.id);
      ref();
    });

    const refFailed = TemplatePostActions.duplicateMediaAsset.failed.listen((error) => {
      logger.error("PerformanceEditor", "unable to duplicate media asset", { error });
      resolve(mediaAssetId);
      refFailed();
    });

    TemplatePostActions.duplicateMediaAsset(mediaAssetId);
  });
};
